/**
 * Wann die App von selbst neu laden darf (26.10.2026, `update.ts`) — eigenes
 * Modul, damit Tests es ohne Service Worker prüfen können.
 */

import { db } from '../db/local.js';
import type { KraftwerkDatabase } from '../db/local.js';
import { openSession } from '../db/workouts.js';

/** Wird gerade getippt? Dann nie neu laden — der halbe Satz wäre weg. */
function typing(): boolean {
  const active = document.activeElement;
  if (!(active instanceof HTMLElement)) return false;
  return (
    active instanceof HTMLInputElement ||
    active instanceof HTMLTextAreaElement ||
    active instanceof HTMLSelectElement ||
    active.isContentEditable
  );
}

/** Ruhig genug zum Neuladen: keine laufende Einheit, keine Eingabe. */
export async function safeToReload(database: KraftwerkDatabase = db): Promise<boolean> {
  if (document.visibilityState !== 'visible' || typing()) return false;
  try {
    return (await openSession(database)) === null;
  } catch {
    return false;
  }
}
